// src/redux/reducer/notificationReducer.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BASE_URL from "../constent";

export const editNotificationToRead = createAsyncThunk(
  "notifications/editNotificationToRead",
  async ({ notiId, data }, thunkAPI) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No access token found");
      const response = await axios.put(
        `${BASE_URL}/myData/notification/${notiId}`,
        data,
        {
          headers: {
            token: token,
          },
        }
      );
      // console.log(response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

//  Subscribe
export const sendSubscribeSettings = createAsyncThunk(
  "notifications/sendSubscribeSettings",
  async (data, thunkAPI) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No access token found");
      // console.log(data)
      const response = await axios.post(`${BASE_URL}/news`, data, {
        headers: {
          token: token,
        },
      });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Initial state and reducers
const notificationSlice = createSlice({
  name: "notifications",
  initialState: {
    notifications: [],
    loading: false,
    error: null,
  },
  reducers: {
    // Action to clear the error state
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle editNotificationToRead
      .addCase(editNotificationToRead.pending, (state) => {
        state.loading = true;
      })
      .addCase(editNotificationToRead.fulfilled, (state, action) => {
        const updatedNotifications = state.notifications.map((notification) =>
          notification.id === action.payload.id
            ? { ...notification, read: true }
            : notification
        );
        state.notifications = updatedNotifications;
        state.loading = false;
      })
      .addCase(editNotificationToRead.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to update notification";
      });
  },
});

// Export the clearError action
export const { clearError } = notificationSlice.actions;

// Export the reducer
export default notificationSlice.reducer;
